import { Button, Col, Form, Input, Row } from "antd";
import Layout from "../layout/Layout";
import styles from "./Login.module.scss";
import ReactInputMask from "react-input-mask";
import { convertPersian, regexFormater, validateInput } from "../../../tools/tools";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { _adr } from "../../../address";
import OTP from "../../../components/otp_modal/otp";
import { useEffect, useState } from "react";
import { setAuthorization, setToken } from "../../../tools/services";
import { useAPIPublic } from "../../../tools/api";
import { useDispatch } from "react-redux";
import { globalValue } from "../../../reducer/serviceReducerGlobala";
import { useLayouts } from "../../layout/layouts";
const Login = () => {
  const { queryCurrentUser } = useAPIPublic();
  const [t] = useTranslation("global");
  const nav = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  //صفحه‌ای که کاربر قبل از ورود در آن بوده؛ اگر ست شده باشد بعد از ورود موفق به همانجا برمی‌گردد
  const returnTo = location.state?.from;

  const { changeLayout } = useLayouts();

  useEffect(() => {
    changeLayout(false);
  }, []);

  //state smsMobile
  const [smsMobile, setSmsMobile] = useState("");
  const [openModalOtp, setOpenModalOtp] = useState(false);

  const handleSubmit = (value) => {
    const msisdn = regexFormater(value?.smsmobileno).removeSpace();
    setSmsMobile(msisdn);
    setOpenModalOtp(true);
  };

  const handleCallBackOtp = async (token) => {
    setOpenModalOtp(false);
    if (token) {
      await setToken({ token: token.token, expireUTCTime: token.expireUTCTime });
      setAuthorization(token.token);
      const resUser = await queryCurrentUser();
      if (resUser?.Code === 1127) {
        changeLayout(true);
        nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.NewUser.Index + _adr.Accounts.NewUser.Profile, {
          state: {
            msisdn: smsMobile,
            from: returnTo,
          },
        });
      } else if (!resUser?.HasError) {
        changeLayout(true);
        dispatch(globalValue({ _currentUser: { ...resUser.Result } }));
        if (returnTo) {
          nav(returnTo, { replace: true });
        } else {
          nav(_adr.Root + _adr.Landing.Index, { replace: true, state: { winner: true } });
        }
      }
    }
  };
  return (
    <Layout>
      <Row justify={"center"}>
        <Col xxl={24} xl={20} lg={15} md={15} sm={15} xs={24}>
          <Form layout="vertical" onFinish={handleSubmit}>
            <Form.Item
              className="input-normal"
              name="smsmobileno"
              rules={[
                validateInput({
                  t: t,
                  validate: true,
                  type: "msisdnOrg",
                }),
              ]}
            >
              <div>
                <ReactInputMask
                  mask="0\999 999 99 99"
                  onInput={(e) => (e.target.value = convertPersian(e.target.value))}
                  dir="ltr"
                  placeholder="شماره موبایل"
                />
              </div>
            </Form.Item>
            <Form.Item>
              <div className="holder-button">
                <Button htmlType="submit" className={`btn-aptel ${styles.btnLogin}`}>
                  ورود با رمز یکبار مصرف
                </Button>

                <Button
                  onClick={(e) => {
                    changeLayout(true);
                    nav(_adr.Root + _adr.Landing.Index);
                  }}
                  htmlType="button"
                  className={`${styles.btnLogin}`}
                >
                  بازگشت
                </Button>
              </div>
            </Form.Item>
          </Form>
        </Col>
      </Row>

      <OTP
        isOpen={openModalOtp}
        msisdn={smsMobile?.length > 0 ? smsMobile.toString().replace("0", "") : ""}
        expiretimebyminute={process.env.REACT_APP_LOGIN_EXPIRE}
        sessionid={Date.now()}
        callback={handleCallBackOtp}
      />
    </Layout>
  );
};

export default Login;
